module.exports = __webpack_public_path__ + "static/media/ex-centralized-img1.5e9c4490.svg";